export const GET_SHARED_ORGANIZATION_DETAILS = "getSharedOrganizationDetails";
